import { useTranslation } from 'react-i18next';
import styles from "./componentLoad.module.css";

const ComponentLoad = () => {
  const { t } = useTranslation(); // hook para traduzir

  return (
    <div className={styles.container}>
        <div className={styles.loadingContainer}>
            <div className={styles.loadingSpinner}>
                <div className={styles.spinner}></div>
            </div>
            <div className={styles.loadingText}>
                <span>{t("componentload.loading")}</span>
                <div className={styles.dots}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    </div>
);
};

export default ComponentLoad;